import { Select } from "antd";
import React, { useEffect, useState } from "react";
import { ROLL_CALL_API_BASE_URL } from "../RollCallConfig/RollCallConfig";
import Swal from "sweetalert2";

const AddRegistration = () => {
  const [branchesData, setBranchesData] = useState([]);
  const [deptData, setDeptData] = useState([]);
  // const [dataLoading, setDataLoading] = useState(false);
  const [submitBtnLoading, setSubmitBtnLoading] = useState(false);
  const [selecteddepartmentid, setselecteddepartmentid] = useState([]);

  const [branchid, setbranchid] = useState([]);
  const [RegEmployee, setRegEmployee] = useState({
    Name: "",
    EmpId: "",
    BioId: "",
    Mobile: "",
    Designation: "",
    Department: "",
    DOJ: "",
    DOB: "",
    Gender: "",
    Branch: "",
    RFID: "",
  });
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [branchError, setBranchError] = useState("");
  const [departmentError, setDepartmentError] = useState("");

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
    }
  }, []);

  useEffect(() => {
    if (tokenData && superIdData) {
      console.log("Token:", tokenData);
      console.log("SuperId:", superIdData);
    }
  }, [tokenData, superIdData]);

  const userData = JSON.parse(sessionStorage.getItem("userData"));

  useEffect(() => {
    if (userData) {
      console.log(userData);
    }
  }, [userData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setRegEmployee((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlebranchChange = (selectedone) => {
    setbranchid(selectedone);
    if (!selectedone) {
      setBranchError("Branch is required.");
    } else {
      setBranchError("");
    }
  };
  const handledepartmentChange = (selectedone) => {
    setselecteddepartmentid(selectedone);
    if (!selectedone) {
      setDepartmentError("Department is required.");
    } else {
      setDepartmentError("");
    }
  };

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchBranches = async () => {
        try {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/branch/getbranch?superid=${superIdData}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            }
          );
          if (!response.ok) {
            throw new Error("Failed to fetch branches");
          }
          const data = await response.json();
          // Correct the check for status
          if (data.status) {
            setBranchesData(data.ResultData);
          } else {
            console.error("Invalid branch response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching branches:", error.message);
        }
      };
      fetchBranches();
    }
  }, [tokenData, superIdData]);

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchDepartments = async () => {
        try {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/department/getdepartment?superid=${superIdData}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch departments");
          }

          const data = await response.json();

          if (data.status) {
            const activeRecords = data.ResultData?.filter(
              (item) => item.isactive
            );
            setDeptData(activeRecords);
          } else {
            console.error("Invalid department response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching departments:", error.message);
        }
      };
      fetchDepartments();
    }
  }, [tokenData, superIdData]);

  console.log(deptData);

  const branchOptions =
    branchesData &&
    branchesData.map((item) => ({
      value: item.branchid,
      label: item.Name,
    }));

  const departmentOptions =
    deptData &&
    deptData.map((item) => ({
      value: item.departmentid,
      label: item.Name,
    }));

  const handleAddEmployee = async (e) => {
    e.preventDefault();
    setSubmitBtnLoading(true);

    let isValid = true;

    if (!branchid || branchid.length === 0) {
      setBranchError("Branch is required.");
      isValid = false;
    } else {
      setBranchError("");
    }

    if (!selecteddepartmentid || selecteddepartmentid.length === 0) {
      setDepartmentError("Department is required.");
      isValid = false;
    } else {
      setDepartmentError("");
    }

    if (!tokenData || !superIdData) {
      console.error("Missing token or superId");
      setSubmitBtnLoading(false);
      return;
    }

    if (!isValid) {
      setSubmitBtnLoading(false);
      return;
    }

    const requestBody = {
      superid: superIdData,
      badge: RegEmployee?.EmpId || "",
      username: RegEmployee?.Name || "",
      dateofbirth: RegEmployee?.DOB || "",
      designation: RegEmployee?.Designation || "",
      cardid: RegEmployee?.EmpId || "",
      mobile: RegEmployee?.Mobile || "",
      rfid: RegEmployee?.RFID || "",
      gender: RegEmployee?.Gender,
      branchid: branchid,
      departmentid: selecteddepartmentid,
      doj: RegEmployee?.DOJ || "",
      createdby: userData?.RegId,
    };

    console.log("Submitting request with body:", requestBody);

    try {
      const response = await fetch(
        `${ROLL_CALL_API_BASE_URL}portal/emp/createEmployee`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tokenData}`,
          },
          body: JSON.stringify(requestBody),
        }
      );

      const responseData = await response.json();
      console.log("API Response:", responseData);

      if (responseData.status) {
        Swal.fire({
          title: "Success",
          text: "Employee added successfully",
          icon: "success",
        }).then(() => {
          window.location.reload();
        });
      } else {
        Swal.fire({
          title: "Error",
          text: responseData?.ErrorMsg || "Failed to submit request.",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Fetch error:", error);
      Swal.fire({
        title: "Error",
        text: "Something went wrong. Please try again.",
        icon: "error",
      });
    } finally {
      setSubmitBtnLoading(false);
    }
  };

  const resetRegEmployee = () => {
    setRegEmployee({
      Name: "",
      EmpId: "",
      BioId: "",
      Mobile: "",
      Designation: "",
      Department: "",
      DOJ: "",
      DOB: "",
      Gender: "",
      Branch: "",
      RFID: "",
    });
    setDepartmentError("");
    setBranchError("");
  };

  useEffect(() => {
    const offcanvasEl = document.getElementById("offcanvasRightAddReg");

    const handleOffcanvasClose = () => {
      resetRegEmployee();
    };

    if (offcanvasEl) {
      offcanvasEl.addEventListener("hidden.bs.offcanvas", handleOffcanvasClose);
    }

    return () => {
      if (offcanvasEl) {
        offcanvasEl.removeEventListener(
          "hidden.bs.offcanvas",
          handleOffcanvasClose
        );
      }
    };
  }, []);

  return (
    <div>
      <style>
        {`
        @media (max-width: 576px) {
          #offcanvasRightAddReg {
            width: 90% !important;
          }
        }

        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasRightAddReg {
            width: 55% !important;
          }
        }

        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasRightAddReg {
            width: 40% !important;
          }
        }
          
       @media (min-width: 1441px) and (max-width:2550px) {
          #offcanvasRightAddReg {
            width: 28% !important;
          }
        }
        @media (min-width:2551px) {
          #offcanvasRightAddReg {
            width:20% !important;
          }
        }
        `}
      </style>
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightAddReg"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">Add Registration</h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <hr className="m-0 p-0" />
        <div className="offcanvas-body">
          <form onSubmit={handleAddEmployee}>
            <div className="content">
              <div className="row">
                <div className="col-6 mb-2">
                  <label className="form-label">
                    <span className="text-danger ms-1">*</span>Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter name"
                    name="Name"
                    value={RegEmployee.Name}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="col-6 mb-2">
                  <label className="form-label">
                    <span className="text-danger ms-1">*</span>Emp ID
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter ID"
                    name="EmpId"
                    value={RegEmployee.EmpId}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="col-6 mb-2">
                  <label className="form-label">
                    <span className="text-danger ms-1">*</span>Biometric
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter biometric ID"
                    name="BioId"
                    value={RegEmployee.BioId}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="col-6 mb-2">
                  <label className="form-label">DOB</label>
                  <input
                    type="date"
                    className="form-control"
                    name="DOB"
                    value={RegEmployee.DOB}
                    onChange={handleInputChange}
                    max={new Date().toISOString().split("T")[0]} // optional: prevent future DOB
                  />
                </div>

                <div className="col-6 mb-2">
                  <label className="form-label">
                    <span className="text-danger ms-1">*</span>DOJ
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    name="DOJ"
                    value={RegEmployee.DOJ}
                    onChange={handleInputChange}
                    required
                    min={RegEmployee.DOB} // ensures DOJ is after DOB
                  />
                </div>

                <div className="col-6 mb-2">
                  <label className="form-label">
                    <span className="text-danger ms-1">*</span>Mobile
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter mobile no"
                    name="Mobile"
                    value={RegEmployee.Mobile}
                    onChange={handleInputChange}
                    pattern="[0-9]{10}"
                    maxLength={10}
                    required
                  />
                </div>

                <div className="col-6 mb-2">
                  <label className="form-label">
                    {" "}
                    <span className="text-danger ms-1">*</span>Gender
                  </label>
                  <select
                    className="form-select"
                    value={RegEmployee.Gender || ""}
                    name="Gender"
                    onChange={handleInputChange}
                    required
                  >
                    <option value="" disabled>
                      Select Gender
                    </option>
                    <option value="1">Male</option>
                    <option value="0">Female</option>
                  </select>
                </div>
                <div className="col-6 mb-2">
                  <label className="form-label">Designation</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter designation"
                    name="Designation"
                    value={RegEmployee.Designation}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col-6 mb-2 d-none">
                  <label className="form-label">Branch</label>
                  <Select
                    showSearch
                    placeholder="Choose Branch"
                    value={branchid || ""}
                    onChange={handlebranchChange}
                    filterOption={(input, option) =>
                      option?.label.toLowerCase().includes(input.toLowerCase())
                    }
                    options={branchOptions}
                    style={{ width: "100%" }}
                    required
                  />
                  {branchError && (
                    <div className="text-danger small mt-1">{branchError}</div>
                  )}
                </div>

                <div className="col-6 mb-2">
                  <label className="form-label">
                    <span className="text-danger ms-1">*</span>Department
                  </label>
                  <Select
                    showSearch
                    placeholder="Choose Department"
                    value={selecteddepartmentid || ""}
                    onChange={handledepartmentChange}
                    filterOption={(input, option) =>
                      option?.label.toLowerCase().includes(input.toLowerCase())
                    }
                    options={departmentOptions}
                    style={{ width: "100%" }}
                    required
                  />
                  {departmentError && (
                    <div className="text-danger small mt-1">
                      {departmentError}
                    </div>
                  )}
                </div>

                <div className="col-6 mb-2">
                  <label className="form-label">RFID</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter RFID"
                    name="RFID"
                    value={RegEmployee.RFID}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-warning  mt-3 me-2"
                  data-bs-dismiss="offcanvas"
                  onClick={resetRegEmployee}
                >
                  Cancel
                </button>

                <button type="submit" className="btn btn-success  mt-3 me-2">
                  {submitBtnLoading ? "Submitting.." : "Save"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddRegistration;
